import { cn } from "@common/lib/utils"

export type StatusTone = "success" | "warning" | "error" | "info" | "neutral"

const toneColor: Record<StatusTone, string> = {
  success: "bg-semantic-success",
  warning: "bg-semantic-warning",
  error: "bg-semantic-error",
  info: "bg-semantic-info",
  neutral: "bg-muted-foreground",
}

export function StatusDot({
  tone,
  title,
}: {
  tone: StatusTone
  title?: string
}): React.ReactElement {
  return (
    <span
      title={title}
      className={cn("inline-block size-2 shrink-0 rounded-full", toneColor[tone])}
    />
  )
}
